import styled from 'styled-components';
import { color } from '../../../theme/Color';

interface ThemeProps {
  theme: {
    mode: string;
  };
}

export const MainContentContainer = styled.div<ThemeProps>`
  flex: 1;
  overflow: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div<ThemeProps>`
  color: ${({ theme }) =>
    theme.mode === 'light' ? color._131313 : color._efefef};
  display: block;
  font-family: Inter;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 16px;
  margin-left: 0px;
  margin-right: 0px;
`;
